import { render, staticRenderFns } from "./count-down.vue?vue&type=template&id=04553ebd&scoped=true&"
import script from "./count-down.vue?vue&type=script&lang=js&"
export * from "./count-down.vue?vue&type=script&lang=js&"
import style0 from "./count-down.vue?vue&type=style&index=0&id=04553ebd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04553ebd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04553ebd')) {
      api.createRecord('04553ebd', component.options)
    } else {
      api.reload('04553ebd', component.options)
    }
    module.hot.accept("./count-down.vue?vue&type=template&id=04553ebd&scoped=true&", function () {
      api.rerender('04553ebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/count-down.vue"
export default component.exports